import { Star } from 'lucide-react';
import { Testimonial } from '../../types';
import styles from './Testimonials.module.css';

interface TestimonialsProps {
  title?: string;
  subtitle?: string;
  testimonials?: Testimonial[];
}

const Testimonials = ({
  title = 'What Critics Are Saying',
  subtitle = 'Acclaimed by players and press worldwide',
  testimonials = [
    {
      id: '1',
      name: 'Sarah Chen',
      publication: 'GameSpot Magazine',
      rating: 5,
      content: 'Cosmos Horizon redefines the space exploration genre with its stunning visuals and deep, engaging gameplay. A must-play for any sci-fi enthusiast.'
    },
    {
      id: '2',
      name: 'Marcus Webb',
      publication: 'IGN Gaming',
      rating: 5,
      content: 'The attention to detail in Cosmos Horizon is unparalleled. From the vast galaxies to the intense combat, every moment feels epic and meaningful.'
    },
    {
      id: '3',
      name: 'Player Review',
      publication: 'Steam Community',
      rating: 5,
      content: 'Best space game I\'ve ever played. The multiplayer campaigns are incredibly well-designed, and the endless exploration keeps me coming back for more.'
    }
  ]
}: TestimonialsProps) => {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        size={16}
        className={i < rating ? styles.starFilled : styles.starEmpty}
        fill={i < rating ? 'currentColor' : 'none'}
      />
    ));
  };

  return (
    <section id="testimonials" className={styles.testimonials}>
      <div className={styles.background} />

      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>

        {/* Testimonials Grid */}
        <div className={styles.grid}>
          {testimonials.map((testimonial, index) => (
            <article
              key={testimonial.id}
              className={styles.card}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Rating */}
              <div className={styles.rating} aria-label={`${testimonial.rating} out of 5 stars`}>
                {renderStars(testimonial.rating)}
              </div>

              {/* Content */}
              <blockquote className={styles.content}>
                "{testimonial.content}"
              </blockquote>

              {/* Author */}
              <div className={styles.author}>
                <cite className={styles.citation}>
                  <span className={styles.name}>{testimonial.name}</span>
                  {testimonial.publication && (
                    <span className={styles.publication}>{testimonial.publication}</span>
                  )}
                </cite>
              </div>

              {/* Quote Mark */}
              <div className={styles.quoteMark}>"</div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
